import React from 'react';
export function TransitionSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-transparent to-[#00B4D8]/10" data-id="element-248">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-249">
        <p className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-250">
          Cada semana que pasás escribiendo copy mediocre, armando ads que no
          convierten, o planificando a ciegas, es plata que dejás sobre la mesa.
        </p>

        <p className="text-xl md:text-2xl text-white font-medium" data-id="element-251">
          No es que no sepas de tu tema. Es que no tenés un sistema. Y sin
          sistema, cada venta es un accidente.
        </p>

        <p className="text-lg md:text-xl text-gray-400" data-id="element-252">
          Mientras tanto, los que sí tienen un sistema están sacando un producto
          nuevo cada mes, con landings que convierten, emails que venden, y ads
          que escalan.
        </p>

        <p className="text-lg md:text-xl text-gray-400" data-id="element-253">
          La diferencia no es talento. Es que ellos no están haciendo todo desde
          cero cada vez.
        </p>

        <div className="pt-8" data-id="element-254">
          <h3 className="text-2xl md:text-4xl font-bold text-[#00B4D8] leading-tight" data-id="element-255">
            ¿Y si tuvieras 33 especialistas trabajando para vos… pero sin
            sueldos, sin reuniones, y disponibles 24/7?
          </h3>
        </div>
      </div>
    </section>;
}